import React from 'react';
import CustomButton from '../OnboardingComponents/CustomButton';
import { ICONS } from '../../constants/icons';

const EmptyState = ({
  icon = ICONS.emptyState,
  title = 'No data found',
  description = '',
  actionText,
  actionTrailingIconSrc = ICONS.plus,
  actionTrailingIconAlt = '',
  onActionClick,
  size = 'md',
  className = '',
}) => (
  <div
    className={`empty-state${size === 'sm' ? ' empty-state--sm' : ''}${
      className ? ` ${className}` : ''
    }`}
  >
    <img
      src={icon}
      alt=""
      width={80}
      height={80}
      className="empty-state__icon"
      onError={(e) => { e.target.style.display = 'none'; }}
    />
    <h3 className="empty-state__title">{title}</h3>
    {description && <p className="empty-state__description">{description}</p>}
    {actionText && (
      <CustomButton
        variant="primary"
        size={size === 'sm' ? 'sm' : 'md'}
        trailingIconSrc={actionTrailingIconSrc}
        trailingIconAlt={actionTrailingIconAlt}
        onClick={onActionClick}
      >
        {actionText}
      </CustomButton>
    )}
  </div>
);

export default EmptyState;
